import { waLink } from "@/lib/whatsapp";

export const WhatsAppFab = () => (
  <a
    href={waLink("Halo Zoya Beads, saya ingin tanya soal koleksi gelang kamu.")}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat via WhatsApp"
    className="group fixed bottom-6 right-5 z-30 flex items-center gap-3 bg-ink py-3 pl-3 pr-4 text-paper shadow-[0_10px_30px_rgba(45,42,38,0.25)] transition-transform duration-300 hover:-translate-y-1 md:bottom-8 md:right-8"
    data-testid="whatsapp-fab"
  >
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
      <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.13-.42-2.15-1.33-.79-.71-1.33-1.58-1.48-1.88-.15-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.03 1.01-1.03 2.46s1.06 2.86 1.21 3.06c.15.2 2.06 3.28 5.05 4.47.7.3 1.26.48 1.69.62.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35z" />
      <path d="M12.04 2C6.6 2 2.18 6.42 2.18 11.86c0 1.74.46 3.44 1.32 4.94L2 22l5.34-1.4a9.83 9.83 0 004.7 1.2h.01c5.43 0 9.85-4.42 9.85-9.86C21.9 6.42 17.47 2 12.04 2zm0 17.94h-.01a8.2 8.2 0 01-4.17-1.14l-.3-.18-3.1.81.83-3.03-.19-.31a8.1 8.1 0 01-1.24-4.33c0-4.51 3.67-8.18 8.19-8.18 2.19 0 4.24.85 5.79 2.4a8.13 8.13 0 012.39 5.79c0 4.52-3.67 8.17-8.19 8.17z" />
    </svg>
    <span className="text-[11px] uppercase tracking-[0.18em]">Chat</span>
  </a>
);
